import React from "react";

export const Atmosphere = () => (
  <>
    <div className="scanlines" aria-hidden />
    <div className="vignette" aria-hidden />
    <div className="film-grain animate-flicker" aria-hidden />
  </>
);
